import { Stack } from "@mui/material";
import { m } from "framer-motion";

import PressAllBtn from "./components/PressAllBtn";
import RevisionRowBtn from "./components/RevisionRowBtn";
import TransferPositionsHeader from "./components/TransferPositionsHeader";
import FundsList from "./FundsList/FundsList";
import FundsTab from "./FundsTab";
import useFundsSelectionLogic from "./useFundsSelectionLogic";

// ----------------------------------------------------------------------

export const FundsSelections = () => {
	const {
		onPressBack,
		isMobile,
		currentTab,
		onChangeTab,
		fundsAvailable,
		fundNotAvailable,
		isDownMd
	} = useFundsSelectionLogic();

	return (
		<Stack
			component={m.div}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1 }}
			width={isDownMd ? "auto" : 800}
			height={isMobile ? "auto" : 500}
		>
			<TransferPositionsHeader onPressBack={onPressBack} />
			<RevisionRowBtn />
			<FundsTab currentTab={currentTab} onChangeTab={onChangeTab} />
			{currentTab === "available" && fundsAvailable.length !== 0 && <PressAllBtn />}
			{currentTab === "available" && <FundsList data={fundsAvailable} />}
			{currentTab === "not_available" && <FundsList data={fundNotAvailable} isNotAvailable />}
		</Stack>
	);
};

export default FundsSelections;
